import React, { useState } from "react";
import styles from "./contact.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios'

const baseURL = `${process.env.REACT_APP_API_URL}`

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form inputs
        if (!formData.name || !formData.email || !formData.message) {
            setErrorMessage("Please fill out all fields.");
            return;
        }

        try {
            const response = await axios.post(`${baseURL}/profiles/contact_maid_match/`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 200) {
                setSuccessMessage("Thank you for Contacting Us! We'll get back to you soon")
                setErrorMessage('')
                setFormData({name:'', message: '', email: ''})
            }
            console.log("Form Data Submitted:", formData);

            setSuccessMessage("Thank you for contacting us! We'll get back to you soon.");
            setErrorMessage(""); // Clear errors
            setFormData({ name: "", email: "", message: "" }); // Clear form
        } catch (error) {
            console.error("Error submitting the form:", error);
            if (error.response && error.response.data) {
                setErrorMessage(error.response.data.error || "Something went wrong. Please try again.");
            } else {
                setErrorMessage("Something went wrong. Please try again.");
            }
        }
    };

    return (
        <div className={styles.contactUsContainer}>
            <div className={styles.header}>
                <h1>Contact Us</h1>
                <p>Have questions or need assistance? Reach out to us, and we'll be happy to help!</p>
            </div>

            {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
            {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}

            <form onSubmit={handleSubmit} className={styles.contactForm}>
                <div className={styles.formGroup}>
                    <label htmlFor="name">Your Name</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        required
                    />
                </div>

                <div className={styles.formGroup}>
                    <label htmlFor="email">Your Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter your email"
                        required
                    />
                </div>

                <div className={styles.formGroup}>
                    <label htmlFor="message">Your Message</label>
                    <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Write your message here"
                        rows="5"
                        required
                    ></textarea>
                </div>

                <button type="submit" className={styles.submitButton}>Send Message</button>
            </form>

            <div className={styles.contactInfo}>
                <h2>Our Contact Details</h2>
                <div className={styles.infoItem}>
                    <FontAwesomeIcon icon={faPhone} className={styles.icon} />
                    <p>+254701496724</p>
                </div>
                <div className={styles.infoItem}>
                    <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
                    <p>support@maidmatch.com</p>
                </div>
                <div className={styles.infoItem}>
                    <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.icon} />
                    <p>Lumumba Drive, Nairobi, Kenya</p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
